import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.show) = $event)),
    "show-arrow": false,
    placement: $props.placement,
    teleported: false
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["reference", {show_indicator: $props.filterIndicator}]),
        relative: "",
        onClick: _cache[0] || (_cache[0] = $event => ($data.show = !$data.show))
      }, [
        (_ctx.$slots.reference)
          ? _renderSlot(_ctx.$slots, "reference", { key: 0 }, undefined, true)
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($options.filter_indicator)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: "indicator",
                    class: "indicator",
                    width: "0.7rem",
                    height: "0.7rem",
                    fill: "#0BA5EC",
                    stroke: "var(--base-white)"
                  }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1 /* TEXT */),
              _createVNode(_component_Icon, {
                icon: "chevron-down",
                width: "1.6rem",
                height: "1.6rem"
              })
            ], 64 /* STABLE_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {
        close: () => $data.show = false
      }, undefined, true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "placement"]))
}